import { render, staticRenderFns } from "./SyncWoocommerceProducts.vue?vue&type=template&id=dcf7f5ac&scoped=true&lang=pug&"
import script from "./SyncWoocommerceProducts.vue?vue&type=script&lang=js&"
export * from "./SyncWoocommerceProducts.vue?vue&type=script&lang=js&"
import style0 from "./SyncWoocommerceProducts.vue?vue&type=style&index=0&id=dcf7f5ac&scoped=true&lang=css&"
import style1 from "./SyncWoocommerceProducts.vue?vue&type=style&index=1&id=dcf7f5ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf7f5ac",
  null
  
)

/* custom blocks */
import block0 from "./SyncWoocommerceProducts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VImg,VLayout,VProgressCircular,VRow,VTextField})
